const EK_STORE_BASE_PRODUCTION = 'https://examkrackers.com/'
const EK_STORE_BASE_STAGING = 'https://examkrackers-qa.fingent.net/'

export const EK_BASE_URL =
  process.env.RELEASE_TYPE === 'production'
    ? EK_STORE_BASE_PRODUCTION
    : EK_STORE_BASE_STAGING

// S3 bucket base for onboarding category images
export const EK_STORAGE_BASE_URL =
  'https://examkrackers-storage-test.s3.amazonaws.com/'

// Vimeo player base
export const VIMEO_BASE_URL = 'https://player.vimeo.com/'
